module.exports = __webpack_public_path__ + "static/media/shipstationlogo.5107cc59.svg";